import { useTranslation, Trans } from "react-i18next";

import man from '../../img/Ambassador/man.png'
function PressRelease() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row justify-between gap-[20px]">
            <div className="flex flex-col items-start">
                <p className="bg-[#F1F7FE] rounded-[60px] px-[20px] py-[4px] poppins text-[12px] leading-[1.4] text-[#061A77B2]">{t('ambassador.4')}</p>
                <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[465px] leading-[1.2] mt-[20px]"><Trans>{t('ambassador.5')}</Trans></p>
                <img src={man} className="mt-[20px] xl:mt-[45px]" alt="" />
            </div>
            <div className="xl:max-w-[600px] flex flex-col gap-[20px] xl:gap-0 justify-between">
                <p className="inter text-[14px] text-[#000000B2]">{t('ambassador.6')}</p>
                <p className="inter text-[14px] text-[#000000B2]">{t('ambassador.7')}</p>
                <p className="inter text-[14px] text-[#000000B2]">{t('ambassador.8')}</p>
                <p className="inter text-[14px] text-[#000000B2]">{t('ambassador.9')}</p>
            </div>
        </div>
    </div>
  );
}

export default PressRelease;
  